/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Empty_DatesInputs */

const en_tl_empty_dates = /** @type {(inputs: Tl_Empty_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing here has dates yet.`)
};

const de_tl_empty_dates = /** @type {(inputs: Tl_Empty_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier hat noch nichts Termine.`)
};

/**
* | output |
* | --- |
* | "Nothing here has dates yet." |
*
* @param {Tl_Empty_DatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_empty_dates = /** @type {((inputs?: Tl_Empty_DatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Empty_DatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_empty_dates(inputs)
	return en_tl_empty_dates(inputs)
});